
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 127 139"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 135h127v4H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M3.958 102.535L106.488.005l20.52 20.52-102.53 102.53zM3.95 102.53l-2.82 23.35 23.34-2.83z"}}),_c('path',{attrs:{"d":"M3.951 102.531l4.243-4.243 20.52 20.52-4.243 4.243zM90.596 15.883l4.243-4.243 20.52 20.52-4.242 4.243z"}})])
          )
        }
      }
    